import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { PropsSmartFieldLocalized, DrugType } from './index'
import { searchDrugComponentService, searchDrugService } from '../../../services';
import AutocompleteSherwood from '../Autocomplete';
import DrugResultOption from './DrugResultOption';
import { useOffline } from '../../../hooks';
import { OfflineField } from './OfflineField';

interface Props extends LocalizeContextProps {
    error:boolean;
    chemicalComponent?:boolean,
    country:string,
    type:string,
    freeSolo:boolean,
    variant:"standard" | "filled" | "outlined" | undefined,
    drugSelected:(drug:DrugType) => void,
    callbackError:(error:boolean) => void,
    initialValue?: DrugType | null
}
function DrugSelector(props: Props) {
    const offline = useOffline();
    const [drug, setDrug] = useState<DrugType | null>(props.initialValue || null);
    const [errorDrug, setErrorDrug] = useState(false);
    // SHER-564: the current investigation's uuid lets the API also merge its pharmacy stock into
    // the drug results. Read from redux so callers don't have to thread it through every layer.
    const uuidInvestigation = useSelector((state: any) => state.investigations?.currentInvestigation?.uuid);

    // Update drug when initialValue changes (for editing)
    useEffect(() => {
        if (props.initialValue) {
            // Only update if the drug actually changed
            if (!drug || drug.id !== props.initialValue.id || drug.name !== props.initialValue.name) {
                setDrug(props.initialValue);
            }
        } else if (!props.initialValue && drug !== null) {
            setDrug(null);
        }
    }, [props.initialValue]);
    
    
    function drugSelected(drug:DrugType){
        console.log(drug);
        setErrorDrug(false);
        setDrug(drug);
        props.drugSelected(drug);
    }
    function getOffline(value:string){
        const drugSelected:DrugType = {name:value, id:"offline"};
        console.log("Offline Drug Selected: ", drugSelected);
        props.drugSelected(drugSelected);
    }
    if(offline){
        return <OfflineField label={props.translate(`hospital.select-${props.type}`).toString()} 
                    error={props.error} variant={props.variant} 
                    callbackOffline={(value) => getOffline(value)} />
    }    
    return(
        <AutocompleteSherwood label={props.translate("hospital.select-treatment").toString()} 
            error={props.error} 
            remoteSearch={props.chemicalComponent ? searchDrugComponentService : searchDrugService}
            // SHER-564: only the drug search carries uuidInvestigation (→ pharmacy-stock merge); the
            // chemical-component search keeps a single {country} param so its URL stays unchanged.
            params={props.chemicalComponent ? { country: props.country } : { country: props.country, uuidInvestigation }}
            getOptionsResponse={props.chemicalComponent ? (response) => response.drugComposition : (response) => response.drugs}
            freeSolo = { props.freeSolo}
            onValueSelected={(value) =>drugSelected(value)}
            getOptionLabel={(option) => option.name}
            renderOption={props.chemicalComponent ? undefined : (option) => (
                <DrugResultOption name={option.name} source={option.source}
                    pharmacyLabel={props.translate('hospital.pharmacy-badge').toString()} />
            )}
            initialValue={drug}/>
    )
}

export default withLocalize(DrugSelector);